export const CLEAR_COMMENT_LIST = 'CLEAR_COMMENT_LIST'
export const UPDATE_COMMENT_LIST = 'UPDATE_COMMENT_LIST'
export const POST_COMMENT = 'fulcrum/containers/Approval/CommentSection/POST_COMMENT'
export const POST_COMMENT_START = 'fulcrum/containers/Approval/CommentSection/POST_COMMENT_START'
export const POST_COMMENT_SUCCESS = 'fulcrum/containers/Approval/CommentSection/POST_COMMENT_SUCCESS'
export const POST_COMMENT_ERROR = 'fulcrum/containers/Approval/CommentSection/POST_COMMENT_ERROR'
export const FETCH_COMMENTS = 'fulcrum/containers/Approval/CommentSection/FETCH_COMMENTS'
export const FETCH_COMMENTS_START = 'fulcrum/containers/Approval/CommentSection/FETCH_COMMENTS_START'
export const FETCH_COMMENTS_SUCCESS = 'fulcrum/containers/Approval/CommentSection/FETCH_COMMENTS_SUCCESS'
export const FETCH_COMMENTS_ERROR = 'fulcrum/containers/Approval/CommentSection/FETCH_COMMENTS_ERROR'

export const WORKFLOW_COMMENT_TYPE = 'approval'
